import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import About from "./pages/About";
import { PageLoader, ToastProvider } from "./components/ui";
import RequireAuth from "./components/RequireAuth";

const Home = lazy(() => import("./pages/Home"));
const Login = lazy(() => import("./pages/Login"));
const Profile = lazy(() => import("./pages/Profile"));
const HrmsRoutes = lazy(() => import("./routes/HrmsRoutes"));
const CrmRoutes = lazy(() => import("./routes/CrmRoutes"));
const UsersRoutes = lazy(() => import("./routes/UsersRoutes"));
const InventoryRoutes = lazy(() => import("./routes/InventoryRoutes"));

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Suspense fallback={<PageLoader label="Loading..." />}>
          <Routes>
            {/* <Route path="/" element={<Home />} /> */}
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<RequireAuth><Home /></RequireAuth>} />
            <Route path="/profile" element={<RequireAuth><Profile /></RequireAuth>} />
            {/* <Route path="/about" element={<About />} /> */}
            <Route path="/hrms/*" element={<RequireAuth><HrmsRoutes /></RequireAuth>} />
            <Route path="/crm/*" element={<RequireAuth><CrmRoutes /></RequireAuth>} />
            <Route path="/users/*" element={<RequireAuth><UsersRoutes /></RequireAuth>} />
            <Route path="/inventory/*" element={<RequireAuth><InventoryRoutes /></RequireAuth>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
